/**
 * Main Dashboard youtube video links
 */

export const mainDashboardVideoLinks = () => {
  return 'https://www.youtube.com/watch?v=hzy4LXYg_2A';
  // return 'https://www.youtube.com/watch?v=n348hOrtDAs';
  // return "https://youtu.be/g83w6LHodJA"
  // return "https://www.youtube.com/watch?v=FiX85JNYmow"
};
export const investmentDashboardVideoLinks = () => {
  return 'https://youtu.be/WCILULIpFrw?feature=shared&t=1';
  // return "https://youtu.be/1CJL4NUr_CA"
  // return "https://www.youtube.com/watch?v=FiX85JNYmow"
};
export const affiliateDashboardVideoLinks = () => {
  return 'https://youtu.be/qaKVCe1ieaQ';
  // return 'https://www.youtube.com/watch?v=JQFDeNnku8w';
  // return "https://youtu.be/JFAo6-hF5Do"
};
export const investorDashboardVideoLinks = () => {
  return 'https://youtu.be/fZ7N6DQx-G4';
  // return 'https://www.youtube.com/watch?v=DQzDc9gXT1Y';
  // return "https://youtu.be/JFAo6-hF5Do"
};
export const walletDashboardVideoLinks = () => {
  return 'https://youtu.be/BJw9KrSfp8c';
  // return 'https://youtu.be/q6R69tvRqLU';
  // return "https://youtu.be/JFAo6-hF5Do"
};
export const voucherVideoLinks = () => {
  return 'https://youtu.be/vW2Z-b2QMdk';
  // return 'https://www.youtube.com/watch?v=68lwDwHssXY';
  // return "https://youtu.be/68lwDwHssXY"
};
export const voucherDashboardVideoLinks = () => {
  return 'https://youtu.be/68lwDwHssXY';
};
export const productSettingsVideoLinks = () => {
  return 'https://youtu.be/CpFQL3Hf8Zc';
};
export const profileSettingsVideoLinks = () => {
  return 'https://youtu.be/BdfdXO2ymrg';
  // return 'https://youtu.be/a7zqZuqDxKE';
};
export const connectBrokerVideoLinks = () => {
  return 'https://youtu.be/49W9myEyKwo';
};
export const myPlansBrokerVideoLinks = () => {
  return 'https://youtu.be/5nQNU7wwbqw?si=Llk87GU_4bDxvk-H&t=103';
  // return 'https://youtu.be/g1KSgkNMhAk?feature=shared&t=103';
};
export const myPlansVideoLinks = () => {
  return 'https://youtu.be/5nQNU7wwbqw?si=9mrLvN6vTX2U2Y6U&t=27';
  // return 'https://www.youtube.com/watch?v=5nQNU7wwbqw';
  // return '	https://www.youtube.com/watch?v=g1KSgkNMhAk';
};
export const myPlansDashboardVideoLinks = () => {
  return 'https://youtu.be/5nQNU7wwbqw?si=RsA2S1GzrDcsZxn1&t=50';
  // return 'https://www.youtube.com/watch?v=5nQNU7wwbqw';
  // return '	https://www.youtube.com/watch?v=g1KSgkNMhAk';
};
export const earningsDashboardVideoLinks = () => {
  return 'https://www.youtube.com/watch?v=LvkC4RwEOLM';
};
export const newPlansVideoLinks = () => {
  return 'https://youtu.be/W3QEhO_IMK8';
};
export const productInfoVideoLink = () => {
  return 'https://youtu.be/m_SoXG0HbLk';
};

export const cashDepositVideoLinks = () => {
  return 'https://www.youtube.com/watch?v=PgEwlX6WeEY';
};
export const upgradeProfileVideoLinks = () => {
  return 'https://www.youtube.com/watch?v=5JR-fYY8bMc';
  // return 'https://youtu.be/5JR-fYY8bMc';
};
export const marketingRoolkitVideoLinks = () => {
  return 'https://youtu.be/i1r1QCck52I';
};
export const changePasswordVideoLinks = () => {
  return 'https://www.youtube.com/watch?v=CTPuOTPobFI';
};

export const embededVideoBrokerSelection = () => {
  return 'https://www.youtube.com/embed/yt02Gex4xOY?si=Apjf6ITJbrmljlg5%22';

}
export const performanceFeeLink = () => {
  return 'https://youtu.be/qg4_LfX1698';

}
export const affiliateCommissionLink = () => {
  return 'https://www.youtube.com/watch?v=TyErqcTsO-s';

}
export const investorCommissionLink = () => {
  return 'https://youtu.be/rQf5Yb0ny_8';
}
export const customerSupportLink = () => {
  return 'https://youtu.be/wwLD_yk2OeI';
}
// export const performanceFeeLink = () => {
//   return 'https://youtu.be/qg4_LfX1698';
// }

/**
 * Add new Affiliate video links
 */

export const invitationUser = (userType, activeStep) => {
  if (activeStep >= 0) {
    if (userType === 2) {
      switch (activeStep) {
        case 0:
          return 'https://youtu.be/AndfjDATrlM';
        case 1:
          return 'https://youtu.be/AndfjDATrlM';
        case 2:
          return 'https://youtu.be/AndfjDATrlM';
        case 3:
          return 'https://youtu.be/AndfjDATrlM';
        default:
          return 'https://youtu.be/AndfjDATrlM';
      }
      // switch (activeStep) {
      //   case 0:
      //     return 'https://www.youtube.com/watch?v=ORPH0FOLUPc';
      //   case 1:
      //     return 'https://www.youtube.com/watch?v=ORPH0FOLUPc';
      //   case 2:
      //     return 'https://www.youtube.com/watch?v=ORPH0FOLUPc';
      //   case 3:
      //     return 'https://www.youtube.com/watch?v=ORPH0FOLUPc';
      //   default:
      //     return 'https://www.youtube.com/watch?v=ORPH0FOLUPc';
      // }
    } else if (userType === 1) {
      switch (activeStep) {
        case 0:
          return 'https://youtu.be/TTQ3IgFl1MA';
        case 1:
          return 'https://youtu.be/TTQ3IgFl1MA';
        case 2:
          return 'https://youtu.be/TTQ3IgFl1MA';
        case 3:
          return 'https://youtu.be/TTQ3IgFl1MA';
        default:
          return 'https://youtu.be/TTQ3IgFl1MA';
      }
      // switch (activeStep) {
      //   case 0:
      //     return 'https://youtu.be/OfAM5y-YwBA';
      //   case 1:
      //     return 'https://youtu.be/OfAM5y-YwBA';
      //   case 2:
      //     return 'https://youtu.be/OfAM5y-YwBA';
      //   case 3:
      //     return 'https://youtu.be/OfAM5y-YwBA';
      //   default:
      //     return 'https://youtu.be/OfAM5y-YwBA';
      // }
    } else if (userType === 3) {
      switch (activeStep) {
        case 0:
          return 'https://youtu.be/THAgUabGi_w';
        case 1:
          return 'https://youtu.be/THAgUabGi_w';
        case 2:
          return 'https://youtu.be/THAgUabGi_w';
        case 3:
          return 'https://youtu.be/THAgUabGi_w';
        default:
          return 'https://youtu.be/THAgUabGi_w';
      }
    } else if (userType === 4) {
      switch (activeStep) {
        case 0:
          return 'https://youtu.be/X9NATG4jpS8';
        case 1:
          return 'https://youtu.be/X9NATG4jpS8';
        case 2:
          return 'https://youtu.be/X9NATG4jpS8';
        case 3:
          return 'https://youtu.be/X9NATG4jpS8';
        default:
          return 'https://youtu.be/X9NATG4jpS8';
      }
    }
  } else {
    if (userType === 2) {
      return 'https://www.youtube.com/embed/yafLCWcu7q8';
    } else if (userType === 1) {
      return 'https://www.youtube.com/embed/eP3IyJAMb8U';
    } else if (userType === 3) {
      return 'https://youtu.be/THAgUabGi_w';
    }
    else if (userType === 4) {
      return 'https://youtu.be/X9NATG4jpS8';
    }
  }
};

export const affiliateTabScreen = (tabValue) => {
  switch (tabValue) {
    case 0:
      return "https://youtu.be/JQFDeNnku8w?si=vfTRSGFLp9lEaYrZ&t=84"
    case 1:
      return "https://youtu.be/JQFDeNnku8w?si=da3vptl9wj4FrRJZ&t=114"
    case 2:
      return "https://youtu.be/JQFDeNnku8w?si=7u4QF-vgXAVnNrx6&t=132"
    case 3:
      return 'https://youtu.be/agbs-MrPXVI?si=S68qvl7fb-TGG42P';

    default:
      break;
  }
};

/**
 * plan selection url
 */

export const selectPlanVideoLinks = () => {
  return 'https://youtu.be/yTr0ywOzMu0';
};
export const updatePlanVideoLinks = () => {
  return 'https://www.youtube.com/watch?v=ZpG3G6V79-4';
};
